import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import InvoiceDialog from './InvoiceDialog';

const CustomerTransactionsDialog = ({ open, onClose, transactions, loading, customerName, onInvoiceClick }) => {
  const [invoiceDialogOpen, setInvoiceDialogOpen] = React.useState(false);
  const [selectedInvoice, setSelectedInvoice] = React.useState(null);

  const handleInvoiceClick = (invoice) => {
    setSelectedInvoice(invoice);
    setInvoiceDialogOpen(true);
    if (onInvoiceClick) onInvoiceClick(invoice);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Transactions for {customerName}</DialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Invoice #</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Cashier</TableCell>
                    <TableCell align="right">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions.length === 0 ? (
                    <TableRow><TableCell colSpan={4}>No transactions found.</TableCell></TableRow>
                  ) : transactions.map((sale) => (
                    <TableRow key={sale._id}>
                      <TableCell>
                        <span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={() => handleInvoiceClick(sale)}
                        >
                          {sale._id.slice(-6).toUpperCase()}
                        </span>
                      </TableCell>
                      <TableCell>{new Date(sale.createdAt).toLocaleString()}</TableCell>
                      <TableCell>{sale.user?.username || 'Unknown'}</TableCell>
                      <TableCell align="right">{sale.total?.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>
  <InvoiceDialog open={invoiceDialogOpen} onClose={() => setInvoiceDialogOpen(false)} sale={selectedInvoice} />
    </>
  );
};

export default CustomerTransactionsDialog;
